/**
 * Parallax Effect
 * Aplica efecto parallax a elementos con la clase .paralax_effect
 */

class ParallaxEffect {
  constructor() {
    this.parallaxElements = document.querySelectorAll('.paralax_effect');
    this.init();
  }

  init() {
    if (this.parallaxElements.length === 0) return;

    // Aplicar efecto parallax en scroll
    this.handleScroll();
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    
    // Recalcular en resize
    window.addEventListener('resize', () => this.handleScroll(), { passive: true });
  }

  handleScroll() {
    this.parallaxElements.forEach(element => {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Solo aplicar parallax si el elemento está visible en viewport
      if (rect.top < windowHeight && rect.bottom > 0) {
        const scrolled = window.pageYOffset;
        const elementTop = rect.top + scrolled;
        const elementHeight = element.offsetHeight;
        
        // Calcular porcentaje de scroll del elemento (0 = arriba del viewport, 1 = abajo del viewport)
        const scrollPercent = (scrolled + windowHeight - elementTop) / (windowHeight + elementHeight);
        
        // Calcular offset: de -10% a +10% para mantener la imagen siempre cubriendo
        // Cuando está arriba del viewport: -10% (imagen más arriba)
        // Cuando está abajo del viewport: +10% (imagen más abajo)
        const offsetPercent = (scrollPercent - 0.5) * 20; // Rango de -10% a +10%
        
        // Aplicar transformación a la imagen de fondo
        const img = element.querySelector('img');
        if (img) {
          img.style.transform = `translateY(${offsetPercent}%)`;
        }
        
        // También aplicar al contenedor de la imagen si existe
        const bgContainer = element.querySelector('.background-image-container');
        if (bgContainer) {
          bgContainer.style.transform = `translateY(${offsetPercent}%)`;
        }
      }
    });
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ParallaxEffect();
  });
} else {
  new ParallaxEffect();
}

// Reinicializar después de que Shopify Section Rendering cargue contenido
document.addEventListener('shopify:section:load', () => {
  new ParallaxEffect();
});
